import { ApplicationRoles, ApplicationRole } from "@edl-development/edl-common";

export class AccessRoleHelper {        

    private static GetPermissionPriority(accessLevel: number) {
        switch(accessLevel) {
            case ApplicationRoles.USER:
                return 1;
            case ApplicationRoles.LIMITED_SUPERVISOR:
                return 2;
            case ApplicationRoles.SUPERVISOR:
                return 3;
            case ApplicationRoles.ADMIN:
                return 4;
            case ApplicationRoles.EDLADMIN:
                return 5;
            default:
                return 0;
        }
    }

    public static GetAccessRoleLabel(accessLevel: number) {
        switch(accessLevel) {
            case ApplicationRoles.USER:
                return "Basic User";
            case ApplicationRoles.SUPERVISOR:
                return "Supervisor User";
            case ApplicationRoles.ADMIN:
                return "Administrative User";
            case ApplicationRoles.LIMITED_SUPERVISOR:
                return "Limited Supervisor";
            case ApplicationRoles.ARCHIVE:
                return "Archived";
        }
    }

    public static AccessLevelToApplicationRole(accessLevel: number, roles: ApplicationRole[]) {
        const roleIndex = roles.findIndex(r => r.AccessId == accessLevel);
        return roleIndex !== -1 ? roles[roleIndex] : null;
    }

    public static isUser(accessLevel: number) {
        return this.GetPermissionPriority(accessLevel) >= this.GetPermissionPriority(ApplicationRoles.USER);
    }

    public static isLimitedSupervisor(accessLevel: number) {
        return this.GetPermissionPriority(accessLevel) >= this.GetPermissionPriority(ApplicationRoles.LIMITED_SUPERVISOR);
    }

    public static isSupervisor(accessLevel: number) {
        return this.GetPermissionPriority(accessLevel) >= this.GetPermissionPriority(ApplicationRoles.SUPERVISOR);
    }

    public static isAdmin(accessLevel: number) {
        return this.GetPermissionPriority(accessLevel) >= this.GetPermissionPriority(ApplicationRoles.ADMIN);
    }

    public static isEDLAdmin(accessLevel: number) {
        return this.GetPermissionPriority(accessLevel) >= this.GetPermissionPriority(ApplicationRoles.EDLADMIN);
    }
}